var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"with-back-btn align-center",attrs:{"data-focus":""}},[_vm._v(" Receive Opera FTM "),_c('FBackButton',{ref:"backButton",attrs:{"route-name":"account-history"}})],1),_c('f-card',{staticClass:"receive-coins f-card-double-padding"},[_c('ReceiveFTM')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }